import { Experiment as MarvelExperiment, Variant as MarvelVariant } from '@marvelapp/react-ab-test';
import marvelEmitter from '@marvelapp/react-ab-test/lib/emitter';
import sample from 'lodash/sample';
import dynamic from 'next/dynamic';
import { withRouter } from 'next/router';
import PropTypes from 'prop-types';
import { PureComponent, useEffect } from 'react';
import Error from '/components/Error';
import { AccountProvider } from '/imports/core/api/accounts/accountContext';
import { CURRENT_USER } from '/imports/core/api/apollo/client/queries';
import { withIntl } from '/imports/core/api/useIntl';
import {
  ACTIVE_BRUNEI_EXP_DESKTOP_LOCALE,
  ACTIVE_BRUNEI_EXP_MOBILE_LOCALE,
  AiSelectWon,
  cookieParser,
  expToogleLocaleToTest,
  removeExperiment,
} from '/lib/helpers';
// import NewonboardingHeader from '/imports/newonboarding/ui/components/OnboardingHeader';
import { withWindowSize } from 'imports/core/api/useWindowSize';
import { getCurrentBreakpoint } from 'styles/mixins';
import { withResponsiveContext } from '/imports/core/api/responsiveContext';
import { withTracking } from '/imports/core/hooks/useTracking';

const OnboardingStartDynamic = dynamic(() => import('/imports/onboarding/ui/components/OnboardingStart'), {
  ssr: false,
});
// const NewOnboardingStartDynamic = dynamic(() => import('/imports/newonboarding/ui/components/OnboardingStart'));
@withIntl
@withTracking
@withWindowSize
@withResponsiveContext
@withRouter
class Onboarding extends PureComponent {
  static propTypes = {
    pageProps: PropTypes.object,
    router: PropTypes.object,
    trackEvent: PropTypes.func,
    host: PropTypes.string,
    apolloClient: PropTypes.any,
    trackUserIdentity: PropTypes.func,
    trackAlias: PropTypes.func,
    locale: PropTypes.string,
  };

  static async getInitialProps(ctx) {
    const token = cookieParser(ctx).token;

    return { token };
  }

  state = {
    loading: true,
    currentUser: null,
    error: undefined,
  };

  componentDidMount() {
    const { pageProps: { token } = {}, router, trackEvent, host, locale, isMobile, width } = this.props;
    const { loading } = this.state;

    if (router.query.from === 'blog') {
      trackEvent('blog_exit_hack', { host });
    }
    removeExperiment('template_view_experiment');
    removeExperiment('download_format_experiment');
    removeExperiment('new_above_cta_experiment');
    removeExperiment('select_template_gender_experiment');
    removeExperiment('experiment_v2_mysmartcv_select_template');
    removeExperiment('exp_template_english_vs_spanish');
    removeExperiment('exp_template_english_vs_french');
    removeExperiment('exp_template_english_vs_brazil');
    removeExperiment('exp_template_english_vs_russain');
    removeExperiment('exp_onboarding_skip_button_mobile');
    removeExperiment('exp_template_english_vs_arabic');
    removeExperiment('exp_template_english_vs_czech');
    removeExperiment('exp_template_english_vs_vietanmese');
    removeExperiment('exp_template_english_vs_malaysian');
    removeExperiment('exp_template_english_vs_crotian');
    removeExperiment('exp_template_english_vs_turkish');
    removeExperiment('exp_template_english_vs_german');
    removeExperiment('exp_template_english_vs_korea');
    removeExperiment('exp_template_english_vs_romanian');
    removeExperiment('exp_template_english_vs_hungarian');
    removeExperiment('exp_template_budapest');
    removeExperiment('exp_template_english_vs_latvian');
    removeExperiment('exp_template_english_vs_polish');
    removeExperiment('exp_template_english_vs_thai');
    removeExperiment('exp_template_english_vs_lathuanian');
    removeExperiment('exp_template_english_vs_estonian');
    removeExperiment('exp_onboarding_select_template_text');
    removeExperiment('exp_template_english_vs_italian');
    removeExperiment('exp_template_english_vs_finnish');
    removeExperiment('exp_template_english_vs_indonesia');
    removeExperiment('exp_template_english_vs_norwegin');
    removeExperiment('exp_template_english_vs_swedish');
    removeExperiment('exp_exit_popup');
    removeExperiment('exp_select_cv_newdesign');
    removeExperiment('exp_popupv2_design');
    removeExperiment('exp_select_cv_newdesignV2_builder');
    removeExperiment('onboarding_new_templates');
    removeExperiment('exp_template_english_vs_japanese');
    removeExperiment('exp_template_english_vs_georgian');
    removeExperiment('exp_template_english_vs_greek');
    removeExperiment('exp_template_english_vs_kazakh');
    removeExperiment('exp_template_english_vs_portuguese');
    removeExperiment('exp_template_english_vs_azerbaijani');
    removeExperiment('exp_template_english_vs_catalan');
    removeExperiment('exp_template_english_vs_tajik');
    removeExperiment('exp_template_english_vs_serbian');
    removeExperiment('exp_ats_preview');
    removeExperiment('exp_template_english_vs_dutch');
    removeExperiment('exp_cali_lima');
    removeExperiment('exp_ats_preview_v2');
    removeExperiment('exp_choose_later_option');

    if (locale === 'fr') removeExperiment('exp_toogle_language');

    const isMobileDevice = ['xs', 'sm'].includes(getCurrentBreakpoint());
    if (isMobileDevice && !ACTIVE_BRUNEI_EXP_MOBILE_LOCALE.includes(locale)) {
      removeExperiment('exp_new_template');
    }
    if (!isMobileDevice && !ACTIVE_BRUNEI_EXP_DESKTOP_LOCALE.includes(locale)) {
      removeExperiment('exp_new_template');
    }

    if (token && loading) {
      // Query Current User only if token exists
      return this.props.apolloClient
        ?.query({ query: CURRENT_USER })
        .then(({ data: { userInfo, loading } }) => {
          this.identifyUser(userInfo, false);

          return this.setState({
            currentUser: userInfo,
            loading,
          });
        })
        .catch((err) => this.setState({ error: err }));
    }

    this.setState({ loading: false });
  }

  identifyUser = (userInfo, register) => {
    const { trackUserIdentity, trackAlias } = this.props;
    trackAlias(userInfo.id);
    trackUserIdentity(userInfo, false, { createdAt: userInfo.createdAt }, register);
  };

  render() {
    const { currentUser, loading, error } = this.state;

    if (error) return <Error />;
    return (
      <AccountProvider
        value={{
          currentUser: currentUser,
          userLoading: loading,
        }}
      >
        <RenderNewSelectCvDesign {...this.props} />
      </AccountProvider>
    );
  }
}

Onboarding.displayName = 'Onboarding';

export default Onboarding;

const RenderNewSelectCvDesign = (props) => {
  const { query } = props.router;
  if (query.from !== 'extension') return <RenderAiDesignABtest {...props} />;
  return (
    <MarvelExperiment name="exp_select_cv_newdesignV2">
      <MarvelVariant name="control">
        <RenderAiDesignABtest {...props} />
      </MarvelVariant>
      <MarvelVariant name="variant_A">
        <RenderAiDesignABtest {...props} />
      </MarvelVariant>
      <MarvelVariant name="variant_B">
        <RenderAiDesignABtest {...props} />
      </MarvelVariant>
    </MarvelExperiment>
  );
};

const RenderAiDesignABtest = (props) => {
  useEffect(() => {
    if (AiSelectWon.includes(props.locale)) {
      removeExperiment('exp_select_cv_ai');
    }
  }, []);
  return <RenderToogleExp {...props} />;
};

const RenderToogleExp = (props) => {
  useEffect(() => {
    const expToogleVariants = ['popup_v2', 'control'];
    if (marvelEmitter.getActiveVariant('exp_toogle_language')) {
      !expToogleVariants.includes(marvelEmitter.getActiveVariant('exp_toogle_language')) &&
        marvelEmitter.setActiveVariant('exp_toogle_language', sample(expToogleVariants));
    }
    if (!expToogleLocaleToTest.includes(props.locale)) {
      removeExperiment('exp_toogle_language');
    }
  }, []);
  if (!expToogleLocaleToTest.includes(props.locale)) return <RenderBruneiExp {...props} isLanding />;

  return (
    <MarvelExperiment name="exp_toogle_language">
      <MarvelVariant name="control">
        <RenderBruneiExp {...props} isLanding />
      </MarvelVariant>
      <MarvelVariant name="popup_v2">
        <RenderBruneiExp {...props} isLanding />
      </MarvelVariant>
    </MarvelExperiment>
  );
};

const RenderBruneiExp = (props) => {
  const isDeviceWidth = typeof window !== 'undefined' && window.innerWidth;
  const isMobileDevice = isDeviceWidth < 980;

  const shouldRenderDefault =
    (isMobileDevice && !ACTIVE_BRUNEI_EXP_MOBILE_LOCALE.includes(props.locale)) ||
    (!isMobileDevice && !ACTIVE_BRUNEI_EXP_DESKTOP_LOCALE.includes(props.locale));

  if (shouldRenderDefault) {
    return <OnboardingStartDynamic {...props} isLanding />;
  }

  return (
    <MarvelExperiment name="exp_new_template">
      <MarvelVariant name="control">
        <OnboardingStartDynamic {...props} isLanding />
      </MarvelVariant>
      <MarvelVariant name="with_brunei">
        <OnboardingStartDynamic {...props} isLanding />
      </MarvelVariant>
    </MarvelExperiment>
  );
};

const localePropTypes = {
  locale: PropTypes.string,
};

RenderToogleExp.propTypes = localePropTypes;
